import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const selectedDeviceAtom = atom({
	key: "selectedDeviceAtom",
	default: null,
	effects_UNSTABLE: [persistAtom],
});
